import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    OnDestroy,
} from "@angular/core";
import { fromEvent, Subscription } from "rxjs";

@Directive({
    selector: "[hVtoScrollSelectAnimation]",
})
export class VtoScrollSelectAnimationDirective implements OnChanges, OnDestroy {
    @Input() public selectAnimation = false;

    private subscription = new Subscription();

    constructor(public elementReference: ElementRef) {}

    public ngOnChanges(changes: SimpleChanges) {
        if (
            changes.selectAnimation &&
            changes.selectAnimation.currentValue &&
            changes.selectAnimation.currentValue !==
                changes.selectAnimation.previousValue
        ) {
            const categoriesTag = document.getElementById("vto-categories");

            if (categoriesTag) {
                this.subscription.add(
                    fromEvent(categoriesTag, "scroll").subscribe(() => {
                        this.updateAnimationPosition(
                            this.elementReference.nativeElement,
                        );
                    }),
                );
            }

            this.updateAnimationPosition(this.elementReference.nativeElement);
        }
    }

    public updateAnimationPosition(activeCategoryElement: HTMLElement) {
        const animation = document.querySelector(".animation");
        if (activeCategoryElement) {
            const parentTag = document.querySelector(".vto-tabs");
            const itemWidth = activeCategoryElement.clientWidth;
            const activeTagCategory =
                activeCategoryElement.getBoundingClientRect().left;
            if (animation && itemWidth > 0) {
                // remove static border form initial selected category tag
                activeCategoryElement.style.border = "none";
                (animation as HTMLElement).style.width = `${itemWidth}px`;
                let parentNodePosition =
                    parentTag?.getBoundingClientRect().left || 0;
                parentNodePosition = Math.abs(parentNodePosition);
                (animation as HTMLElement).style.transform = `translate3d(${
                    activeTagCategory - parentNodePosition
                }px,0,0)`;
            }
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
